module.exports = "//static.hsappstatic.net/marketplace-storefront-base/static-1.6141/assets/images/PartnerInfoIllustration.jpg"